module.exports = __webpack_public_path__ + "img/mask-home-banner-ja.84481b52.png";